"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/alert/style/css");

var _alert = _interopRequireDefault(require("antd/es/alert"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/descriptions/style/css");

var _descriptions = _interopRequireDefault(require("antd/es/descriptions"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _reactRedux = require("react-redux");

var _testkit = require("../../redux/testkit/testkit.types");

var _SecureImage = _interopRequireDefault(require("../../components/image/SecureImage"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _descriptions.default;
const {
  Option
} = _select.default;
const inputStyle = {
  marginTop: '5px',
  marginBottom: '5px'
};

class TestkitNeedsReviewCard extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      reportDate: undefined,
      actualResult: '',
      reviewError: false,
      errorMessage: 'Must provide Actual Result to review a test kit.',
      modalVisible: false
    };

    this.handleReviewTestkit = () => {
      const {
        reviewTestkit,
        testkit
      } = this.props;
      const {
        actualResult,
        reportDate
      } = this.state;

      if (testkit.type.match(/oraquick/i) && actualResult && actualResult.length > 0 && actualResult.match(/(positive|negative|unknown)/i)) {
        const reviewArg = {
          id: testkit.id,
          actualResult
        };
        reviewTestkit(reviewArg);
        this.setState({
          reviewError: false
        });
      } else if (testkit.type.match(/hemaspot/i) && !!reportDate) {
        const reviewArg = {
          id: testkit.id,
          reportDate
        };
        reviewTestkit(reviewArg);
      } else {
        if (testkit.type.match(/oraquick/i)) {
          this.setState({
            reviewError: true,
            errorMessage: 'Must provide Actual Result to review a test kit.'
          });
        } else {
          this.setState({
            reviewError: true,
            errorMessage: 'Must provide Report Date to review a test kit.'
          });
        }

        if (actualResult.length > 0 && !actualResult.match(/(positive|negative|unknown)/i)) {
          this.setState({
            errorMessage: "Actual Result must either be 'positive', 'negative' or 'unknown'"
          });
        }
      }
    };
  }

  componentDidMount() {}

  onChange(state) {
    this.setState(state);
  }

  render() {
    const {
      testkit
    } = this.props;
    const {
      participant
    } = testkit;

    if (!participant) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Participant Not Found.");
    }

    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_descriptions.default, {
      layout: "vertical",
      column: testkit.type.match(/oraquick/i) ? 5 : 3
    }, /*#__PURE__*/_react.default.createElement(Item, {
      label: "Fulfillment",
      span: 1
    }, /*#__PURE__*/_react.default.createElement("span", null, `${testkit.firstName} ${testkit.lastName}`), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, `${testkit.address1}`), /*#__PURE__*/_react.default.createElement("br", null), testkit.address2 ? /*#__PURE__*/_react.default.createElement("span", null, `${testkit.address2}`, /*#__PURE__*/_react.default.createElement("br", null)) : '', /*#__PURE__*/_react.default.createElement("span", null, `${testkit.city}, ${testkit.state} ${testkit.postalCode}`), /*#__PURE__*/_react.default.createElement("br", null)), testkit.type.match(/oraquick/i) ? /*#__PURE__*/_react.default.createElement(Item, {
      label: "Report Date"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: inputStyle
    }, (0, _moment.default)(testkit.reportDate).calendar())) : undefined, /*#__PURE__*/_react.default.createElement(Item, {
      label: "Current Hiv Status"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: inputStyle
    }, participant.actualHivStatus)), testkit.type.match(/oraquick/i) ? /*#__PURE__*/_react.default.createElement(Item, {
      label: "Reported Result"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: inputStyle
    }, testkit.reportedResult)) : undefined, /*#__PURE__*/_react.default.createElement(Item, {
      label: "Actions"
    }, testkit.type.match(/oraquick/i) ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: e => {
        this.onChange({
          modalVisible: true
        });
      },
      style: {
        marginTop: '5px'
      }
    }, "View Image"), /*#__PURE__*/_react.default.createElement("br", null), ' ', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_select.default, {
      placeholder: "Actual Results",
      style: {
        width: 120
      },
      onChange: value => this.onChange({
        actualResult: value
      })
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "POSITIVE"
    }, "POSITIVE"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "NEGATIVE"
    }, "NEGATIVE"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "UNKNOWN"
    }, "UNKNOWN")), /*#__PURE__*/_react.default.createElement(_modal.default, {
      bodyStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      centered: true,
      closable: false,
      visible: this.state.modalVisible,
      onOk: () => this.onChange({
        modalVisible: false
      }),
      onCancel: () => this.onChange({
        modalVisible: false
      })
    }, /*#__PURE__*/_react.default.createElement(_SecureImage.default, {
      url: `/a/testkit/${testkit.participantId}/${testkit.id}/image`,
      alt: "OraQuick test kit."
    })), /*#__PURE__*/_react.default.createElement("br", null)) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      placeholder: "Report Date",
      style: inputStyle,
      onChange: (date, dateString) => this.onChange({
        reportDate: dateString
      })
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this.handleReviewTestkit,
      style: {
        marginTop: '5px'
      }
    }, "Mark Completed"))), /*#__PURE__*/_react.default.createElement(_alert.default, {
      style: this.state.reviewError ? {
        visibility: 'visible'
      } : {
        visibility: 'hidden'
      },
      message: this.state.errorMessage,
      type: "error",
      showIcon: true
    }));
  }

}

const mapDispatchToProps = dispatch => {
  return {
    reviewTestkit: testkit => dispatch(_testkit.reviewTestkitAsync.request(testkit))
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(TestkitNeedsReviewCard);

exports.default = _default;